module.exports = __webpack_public_path__ + "img/hic-transport-accidents-female.cda87dfa.png";